export default __webpack_public_path__ + "a9dc8fea026ed0400b9e3606a4b9739f.svg";